import { useRef, useState } from 'react'
import clsx from 'clsx'
import { TbCameraPlus } from 'react-icons/tb'

import MediaStagingArea from './MediaStagingArea'

interface Props {
  inputName: string
  defaultPic: string | null
}

const MediaContainer: React.FC<Props> = ({ inputName, defaultPic }) => {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null)
  const stagingRef = useRef<HTMLInputElement>(null)

  const handleButtonClick = () => {
    stagingRef.current?.click()
  }

  return (
    <div
      className={clsx(
        'z-[50] flex h-full w-full items-center justify-center bg-cover bg-center',
        {
          'border-theme rounded-full border-2 border-solid':
            inputName === 'profilePicture',
        },
      )}
      style={{
        backgroundImage: previewUrl
          ? `url(${previewUrl})`
          : `url(${defaultPic})`,
        backgroundColor: inputName === 'headerPicture' ? 'gray' : '',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div
        className={clsx('flex h-full w-full items-center justify-center', {
          'rounded-full': inputName === 'profilePicture',
        })}
      >
        <button
          type="button"
          className="h-auto w-auto"
          onClick={handleButtonClick}
        >
          <div
            className={clsx(
              'hover-sub text-main-invert flex h-full w-full cursor-pointer items-center justify-center rounded-full p-[10px] text-3xl transition duration-300 ease-in hover:scale-[1.1]',
              {
                'text-6xl': inputName === 'headerPicture',
              },
            )}
          >
            <TbCameraPlus />
          </div>
        </button>
      </div>
      <MediaStagingArea
        inputName={inputName}
        onPreview={(url) => setPreviewUrl(url)}
        inputRef={stagingRef}
      />
    </div>
  )
}

export default MediaContainer
